import { render, staticRenderFns } from "./DashboardRouter.vue?vue&type=template&id=2f37a76e&"
import script from "./DashboardRouter.vue?vue&type=script&lang=ts&"
export * from "./DashboardRouter.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardRouter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports